// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payments {
  max-width: 820px;
}
.payments .muted {
  color: #64748b;
  font-size: 0.85rem;
  margin: 2px 0 0;
}
.payments .note {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.payments .note.warn {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}
.payments .panel {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 18px 20px;
  margin-bottom: 18px;
  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);
}
.payments .panel h4 {
  margin: 0 0 12px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #0f766e;
}
.payments .method {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}
.payments .method:last-of-type {
  border-bottom: 0;
}
.payments .method p {
  max-width: 560px;
}
.payments .field {
  margin-top: 16px;
}
.payments .field label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
}
.payments .actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 18px;
}
.payments code {
  background: #f1f5f9;
  padding: 1px 6px;
  border-radius: 4px;
  word-break: break-all;
}
/*# sourceMappingURL=payments-settings.component.css.map */`, "",{"version":3,"sources":["webpack://./payments-settings.component.less","webpack://./src/app/settings/payments/payments-settings.component.less"],"names":[],"mappings":"AAEA;EACE,gBAAA;ACDF;ADAA;EAII,cAAA;EACA,kBAAA;EACA,eAAA;ACDJ;ADLA;EAUI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;ACFJ;ADII;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;ACFN;ADrBA;EA4BI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mDAAA;ACJJ;AD7BA;EAoCM,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;ACJN;ADrCA;EA8CI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;ACNJ;ADQI;EACE,gBAAA;ACNN;ADhDA;EAyDQ,gBAAA;ACNR;ADnDA;EA6DI,gBAAA;ACPJ;ADtDA;EAgEM,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ACPN;AD7DA;EAyEI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;ACTJ;ADpEA;EAiFI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;ACVJ;AACA,0DAA0D","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.payments {\n  max-width: 820px;\n\n  .muted {\n    color: #64748b;\n    font-size: 0.85rem;\n    margin: 2px 0 0;\n  }\n\n  .note {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    margin-bottom: 16px;\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n\n    &.warn {\n      background: #fffbeb;\n      border-color: #fde68a;\n      color: #92400e;\n    }\n  }\n\n  .panel {\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    padding: 18px 20px;\n    margin-bottom: 18px;\n    box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n\n    h4 {\n      margin: 0 0 12px;\n      font-size: 0.78rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.07em;\n      color: #0f766e;\n    }\n  }\n\n  .method {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    padding: 12px 0;\n    border-bottom: 1px solid #f1f5f9;\n\n    &:last-of-type {\n      border-bottom: 0;\n    }\n\n    p { max-width: 560px; }\n  }\n\n  .field {\n    margin-top: 16px;\n\n    label {\n      display: block;\n      margin-bottom: 6px;\n      font-size: 0.8rem;\n      font-weight: 600;\n      color: #475569;\n    }\n  }\n\n  .actions {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 18px;\n  }\n\n  code {\n    background: #f1f5f9;\n    padding: 1px 6px;\n    border-radius: 4px;\n    word-break: break-all;\n  }\n}\n",".payments {\n  max-width: 820px;\n}\n.payments .muted {\n  color: #64748b;\n  font-size: 0.85rem;\n  margin: 2px 0 0;\n}\n.payments .note {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  margin-bottom: 16px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n.payments .note.warn {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #92400e;\n}\n.payments .panel {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 18px 20px;\n  margin-bottom: 18px;\n  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n}\n.payments .panel h4 {\n  margin: 0 0 12px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: #0f766e;\n}\n.payments .method {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n.payments .method:last-of-type {\n  border-bottom: 0;\n}\n.payments .method p {\n  max-width: 560px;\n}\n.payments .field {\n  margin-top: 16px;\n}\n.payments .field label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #475569;\n}\n.payments .actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 18px;\n}\n.payments code {\n  background: #f1f5f9;\n  padding: 1px 6px;\n  border-radius: 4px;\n  word-break: break-all;\n}\n/*# sourceMappingURL=payments-settings.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
